'use client';

import { c as _c } from "react/compiler-runtime";
import { env } from '@/env/client.mjs';
import { RefreshRouteOnSave as PayloadLivePreview } from '@payloadcms/live-preview-react';
import { useRouter } from 'next/navigation.js';
import React from 'react';
export const RefreshRouteOnSave: React.FC = () => {
  const $ = _c(2);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = <PayloadLivePreview refresh={() => {
      router.refresh();
    }} serverURL={env.NEXT_PUBLIC_SERVER_URL} />;
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};